/**

@ngdoc directive
@name keyCode

@description
Binds the keypress to the specific behaviour (function).<br />
Some useful keycodes:<br />
9  - Tab<br />
13 - Enter<br />
27 - Esc<br />
32 - space<br />

@usage
    <input type="text" key-code="13" key-press="closeModalWindow();" />
    <input type="text" key-code="24" key-press="submitInformation();" />
// TODO: extend to take an array ie: <input type="text" key-code="[13,24]" key-press="[closeModalWindow();,submitInformation()]" />

*/

(function() {
    'use strict';

function keyPress() {
    return {
        restrict: 'A',
        link: function($scope, $element, $attrs) {
            $element.bind("keypress", function(event) {

                var keyCode = event.which || event.keyCode;

                if (keyCode == $attrs.keyCode) {
                    $scope.$apply(function() {
                        $scope.$eval($attrs.keyPress, {$event: event});
                    });
                }
            });
        }
    };
}
angular.module('app').directive('keyPress', keyPress);

}());
